// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components-ghana/calculator-ghana-business-loan/calculator-ghana-business-loan.component.scss
// module id = 600
// module chunks = 0